<section class="mass-os-review-summary">
  <div class="mass-os-review-summary__info">
    <span class="mass-os-review-summary__period" *ngIf="periodText">
      <mat-icon>calendar_month</mat-icon>
      <span class="mass-os-review-summary__period-kicker">Periodo</span>
      <strong class="mass-os-review-summary__period-text">{{
        periodText
      }}</strong>
    </span>

    <span
      class="mass-os-review-summary__provider"
      *ngIf="selectedProvider as provider"
    >
      <mat-icon>schedule</mat-icon>
      <span class="mass-os-review-summary__provider-kicker">Proveedor</span>
      <strong class="mass-os-review-summary__provider-name">{{
        provider.name
      }}</strong>
    </span>
  </div>

  <div class="mass-os-review-summary__actions">
    <span
      *ngIf="selectedTicketCount > 0"
      class="mass-os-review-summary__ticket-count"
      title="Tickets seleccionados para OS"
    >
      <mat-icon>confirmation_number</mat-icon>
      {{ selectedTicketCount }} ticket{{
        selectedTicketCount === 1 ? '' : 's'
      }} seleccionado{{ selectedTicketCount === 1 ? '' : 's' }}
    </span>

    <button
      mat-stroked-button
      type="button"
      class="mass-os-review-summary__back"
      (click)="back.emit()"
    >
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>

    <button
      mat-flat-button
      color="primary"
      type="button"
      class="mass-os-review-summary__sync"
      [disabled]="selectedServiceCount === 0"
      (click)="syncPaymentDate.emit()"
    >
      {{ generateLabel }}
      <mat-icon>receipt_long</mat-icon>
    </button>
  </div>
</section>
